import React, { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import SubscribeForm from './SubscribeForm'
import ProductInfo from './ProductInfo'
import { PromotionalProductProps } from '../containers/ConnectedPromotionalProduct'

const Product: React.FC<PromotionalProductProps & RouteComponentProps<{ barcode: string }>> = props => {
	useEffect(() => {
		if (props.price === null) {
			props.searchBarcode(props.match.params.barcode)
		}
		// eslint-disable-next-line
	}, [props.price])

	if (typeof props.product === 'undefined') {
		return null
	}

	return (
		<div className="grid">
			<div className="grid__row grid__row--spacing-top-3x grid__row--spacing-bottom">
				<div className="grid__col grid__col--12">
					<div className="title title--align-center">
						{
							props.product?.[`name_${props.locale}`] !== '' ?
								props.product?.[`name_${props.locale}`] :
								props.product?.name
						}
					</div>
				</div>
			</div>

			<div className="grid__col grid__col--10 grid__col--offset-1 grid__col--spacing">
				<div className="video">
					<iframe
						title="RedBull video"
						src="https://player.vimeo.com/video/392922771?color=000000&title=0&byline=0&portrait=0&autoplay=1&loop=1&autopause=0&background=1"
						width="640"
						height="360"
						allow="autoplay; fullscreen"
						className="video__iframe"
					/>
				</div>
			</div>

			<ProductInfo
				product={props.product}
				price={props.price}
				locale={props.locale}
			/>

			<SubscribeForm
				onSubscribe={props.subscribe}
				description="Schrijf je in voor de Red Bull Energy winactie en maak kans op 2 paddock kaarten voor F1 Zandvoort 2021."
			/>
		</div>
	)
}

export default withRouter(Product)
